import { createSelector } from 'reselect'

export const isOrderReviewed = createSelector(
  (state: App.State, orderId: string) => state.review.reviewsByOrder[orderId],
  (state: App.State, orderId: string) => !!state.review.reviewsByOrderLoading[orderId],
  (reviewsByOrder, isLoading) => {
    return !isLoading && !!reviewsByOrder?.length
  },
)

export const isOrderReviewsLoaded = createSelector(
  (state: App.State, orderId: string) => state.review.reviewsByOrder[orderId],
  (state: App.State, orderId: string) => !!state.review.reviewsByOrderLoading[orderId],
  (reviewsByOrder, isLoading) => {
    return !isLoading && !!reviewsByOrder
  },
)
